import styled from 'styled-components';

export const Container = styled.div`
  margin-top: 30px;
  border-radius: 10px;
  background: #fff;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;
  padding: 15px 10px;
  /* overflow: auto; */

  h2 {
    font-family: 'Roboto';
    font-weight: 500;
    font-size: 22px;
    margin-bottom: 15px;
  }
`;


export const Form = styled.form`
  .check-box {
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    gap: 4px;

    svg {
      color: #333;
    }
    .MuiFormControlLabel-root {
      margin-right: 0;
    }
    .css-ahj2mt-MuiTypography-root {
      font-family: 'Inter';
      font-weight: 500;
      color: #333;
      font-size: 15px;
    }
  }
  .input-group {
    width: 100%;
    display: flex;
    /* align-items: center; */
    gap: 20px;
    margin-bottom: 20px;
  }

  .input-group.tripple {
    display: flex;
    flex-direction: column;
    .input-wrapper {
      width: auto;
      /* display: flex; */
      /* flex-direction: column; */
    }
    
    @media(min-width: 600px) {
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
    }
  }

  .input-wrapper {
    width: 100%;
    font-family: 'Roboto';
    font-weight: 400;
    font-size: 1rem;
    line-height: 1.4375em;
    label {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        margin-right: 5px;
        color: rgba(0, 0, 0, 0.6);
    }
    span {
        display: block;
      }
    .input {
        background: #fff;
        width: 100%;
    }

    .value {
        height: 40px;
        padding: 6px 8px;
        border-radius: 6px;
        font-size: 17px;
        color: #333;
        cursor: pointer;

        &.value {
          @media (max-width: 620px) {
            width: 40%;
          }
        }
    }

    .border {
        border: 1px solid #D3D3D3;
    }

    .date {
        height: 40px;
        padding: 6px 8px;
        border: 1px solid #D3D3D3;
        border-radius: 6px;
        font-size: 17px;
        color: #333;
        cursor: pointer;
      }
   }

   .hook-error {
     color: #f7345b;
     font-family: 'Inter';
     font-size: 14px;
   }

   .input-wrapper.text-area {
      width: 100%;
      .text-area {
        width: 100%;
        outline: none;
        min-height: 80px;
        border: 1px solid #D3D3D3;
        border-radius: 6px;
        padding: 6px;
        font-family: 'Roboto';
        font-size: 16px;
        font-weight: 400;
        color: #333;
      }
    }

    .link {
      margin-top: 4px;
      font-size: 14px;
      font-family: 'Inter';
      color: #333;
      a {
          color: #4c83ee;
          &:hover {
              color: #566583
          }
        }
    }

  .actions {
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;
  }
`;



